<template>
  <div>
    <Slider v-if="sliderEnabled" />
    <v-container>
      <shortcuts v-if="shortcutsEnabled" />
      <games-list v-if="gameListEnabled" />
      <bonus-cards v-if="promotionEnabled"/>
      <footer-menu v-if="footerEnabled"/>
    </v-container>
  </div>

</template>

<!---->

<script>
import {config} from '~/plugins/config'
import FooterMenu from '~/layouts/Home/FooterMenu'
import Slider from '~/layouts/Home/Slider'
import BonusCards from '~/layouts/Home/BonusCards'
import GamesList from '~/layouts/Home/GamesList'
import {mapState, mapGetters} from 'vuex'
import Message from '~/components/Message'
import Chat from '~/components/Chat'
import Preloader from '~/components/Preloader'
import {navAdminItems, navUserItems, navAuthUserItems, externalGames} from "~/layouts/menu-items";
import MenuItem from "~/layouts/menu-item"
import MainTabs from "../components/MainTabs";
import MainTabsMobile from "../components/MainMobile";
import MainMobile from "../components/MainMobile";
import Shortcuts from "~/layouts/Home/Shortcuts";

export default {
  name: 'NewHomepage',

  components: {
    Shortcuts,
    MainMobile,
    MainTabs,
    MainTabsMobile,
    BonusCards,
    FooterMenu,
    GamesList,
    Slider,
    Message,
    Chat,
    Preloader,
    MenuItem,
  },
  data() {
    return {
      navigationDrawer: false,
      chatDrawer: false,
      accountMenu: false,
      settingsMenu: false,
      userMenu: false,
      unreadChatMessagesCount: 0,
      navAdminItems,
      navUserItems,
      navAuthUserItems,
      externalGames,
    }
  },
  metaInfo() {
    return {
      title: this.$t('Fair online casino games')
    }
  },
  computed: {
    ...mapState('auth', ['user', 'account', 'token']),
    ...mapState('settings', ['settings']),
    ...mapState('progress', ['loading']),
    ...mapGetters('auth', ['is_user_admin', 'is_user_seller', 'is_user_supervisor']),
    ...mapGetters({
      authenticated: 'auth/check',
      games: 'package-manager/games'
    }),
    isPos(){
      return config('app.is_pos')
    },
    appName() {
      return config('app.name')
    },
    appLogoUrl() {
      return config('app.logo')
    },
    chatEnabled() {
      return config('settings.chat.enabled')
    },
    rafflePackageEnabled() {
      return this.$store.getters['package-manager/get']('raffle')
    },
    paymentsPackageEnabled() {
      return this.$store.getters['package-manager/get']('payments')
    },
    user_role_text() {
      if (this.is_user_admin) return this.$t('Admin')
      if (this.is_user_seller) return this.$t('Seller')
      if (this.is_user_supervisor) return this.$t('Supervisor')
      else return ''
    },
    accountBalance() {
      if (this.account && this.account?.balance != null) {
        return this.account.balance
      }

      return 0;
    },
    sliderEnabled(){
      return config('settings.content.home.slider_view.enabled')
    },
    footerEnabled(){
      return config('settings.content.home.footer.enabled')
    },
    promotionEnabled(){
      return config('settings.content.home.promotion.enabled')
    },
    shortcutsEnabled(){
      return config('settings.content.home.shortcut.enabled')
    },
    gameListEnabled(){
      return config('settings.content.home.game_list.enabled')
    }
  },

  methods: {
    config,
    setUnreadChatMessagesCount(count) {
      this.unreadChatMessagesCount = count
    },
    async logout() {
      // Log out
      await this.$store.dispatch('auth/logout')

      // Redirect to home page
      if (this.$route.name !== 'home') {
        this.$router.push({name: 'home'})
      }
    },
    saveSettings(key, value) {
      // value is null when switch is turned off
      this.$store.dispatch('settings/set', {key, value: !!value})
    }
  }

}
</script>

<style lang="scss" scoped>
.v-main{
  padding: 56px 0 0 !important;
}

.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background: #274492;
}

.v-app-bar--is-scrolled {
  background: #274492 !important;
}

.theme--dark.v-application {
  background: #274492 !important;
}

//
//.theme--dark.v-navigation-drawer,
//.theme--dark.v-sheet,
//.theme--dark.v-data-table,
//.theme--dark.v-tabs > .v-tabs-bar {
//  background-color: #3d68aa!important;
//}
//
//.theme--dark.v-sheet,
.theme--dark.v-footer {
  background-color: transparent !important;
}

.v-navigation-drawer {
  background: #274492 !important;
}

.v-toolbar__title {
  @media screen and (min-width: 576px) {
    min-width: 280px;
  }
}


</style>

<style lang="scss">
.show-whatsapp-mobile {
  @media screen and (min-width: 501px) {
    display: none
  }
}
.show-whatsapp-desktop {
  @media screen and (max-width: 500px) {
    display: none
  }
}

.container {
  @media  (min-width: 959px) and (max-width: 1904px) {
    max-width: 1400px;
  }
}

</style>